(()=>{
  'use strict';
  function initialize(root=document){
    root.querySelectorAll('[data-product-root]').forEach(productRoot=>{
      const select=productRoot.querySelector('[data-variant-select]');
      const variantsNode=productRoot.querySelector('[data-variants]');
      if(!select||!variantsNode||select.dataset.initialized==='true')return;
      select.dataset.initialized='true';
      let variants;try{variants=JSON.parse(variantsNode.textContent)}catch{return}
      select.addEventListener('change',()=>{
        const variant=variants.find(v=>String(v.id)===select.value);if(!variant)return;
        const price=productRoot.querySelector('[data-product-price]');
        const button=productRoot.querySelector('[data-add-button]');
        const currency=document.documentElement.dataset.currency||'USD';
        if(price){try{price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency,currencyDisplay:'code'}).format(variant.price/100)}catch{price.textContent=(variant.price/100).toFixed(2)+' '+currency}}
        if(button){button.disabled=!variant.available;button.childNodes[0].textContent=variant.available?'Add to bag ':'Sold out ';}
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
        const status=document.querySelector('#ArvellocStatus');if(status)status.textContent=variant.available?'Option available.':'Option sold out.';
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('click',event=>{document.querySelectorAll('.mobile-navigation[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.removeAttribute('open')})});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mobile-navigation[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary')?.focus()})});
})();
